/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setBrandTippingConfiguration} from '../api'

export const useMutationSetBrandTippingConfiguration = createReactQueryMutationHook('setBrandTippingConfiguration', setBrandTippingConfiguration)
